<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';
import { inputsStep1 } from './utils/inputsForm';
import {
  calculatePriceForLanding,
  getAssets,
  getSubAssets,
  getProducts
} from '../../repositories/landing.repository';
import { calculatePolicyPrice } from '../../helpers';
import Slider from './Slider.vue';
import NuevaContratacionMX from './NuevaContratacionMX.vue';
import NuevaContratacionAR from './NuevaContratacionAR.vue';
import NuevaContratacionCL from './NuevaContratacionCL.vue';
import { useToast } from '../../composables/useToast';
import storePolicy from '@store/policy';
import getDolarArgentina from '../../helpers/exchangeArgentina';
import { getDolarChile } from '../../helpers/exchangeChile';
import storeAuth from '@store/auth';
import { useI18n } from 'vue-i18n';
import { IAsset } from '../../types/assets.type';
import CompaniesRepository from '@repositories/companies.repository';
import { ICompany } from '../../types/company.type';

const { t } = useI18n();
const store = storePolicy();
const storeUser = storeAuth();
const refTableForm = ref<any>(null);
const toogleForm2 = ref<boolean>(false);
const fieldsStep1: any = ref(inputsStep1());
const endPrice = ref<number>(calculatePolicyPrice(200000));
const indemnificationLimit = ref<number>(200000);
const errorResponse = ref<string | null>(null);
const assetSelected = ref<IAsset | null>(null);
const companyURLSelected = ref<string | null>(null);
const dataForm1 = ref<any>();
const dolarPrice = ref<number | null>(null);
const UFvalue = ref<number | null>(null);
const isButtonDisabled = ref<boolean>(false);
const loading = ref<boolean>(false);
const country = ref({ id: 1, nombre: 'MEXICO' });
const companiesOptions = ref<Array<ICompany>>([]);
const company = ref<ICompany>();
const { $toast } = useToast();

const fetchDolarArgentina = async () => {
  try {
    loading.value = true;
    const cotizations = await getDolarArgentina();
    dolarPrice.value = cotizations;
    store.setProp({ key: 'pricing', value: { dolar: dolarPrice.value } });
    handleSliderChange(dolarPrice.value * 1000);
  } catch (error) {
    $toast?.error(
      t(
        'nueva_operacion.nueva_operacion.hay_un_error_en_la_cotizacion_de_divisas',
      ),
    );
  } finally {
    loading.value = false;
  }
};

const fetchDolarChile = async () => {
  try {
    loading.value = true;
    const cotizations = await getDolarChile();
    if (!cotizations || !cotizations.dolar || !cotizations.uf) {
      $toast?.error(
        t(
          'nueva_operacion.nueva_operacion.hay_un_error_en_la_cotizacion_de_divisas',
        ),
      );
      return;
    }

    dolarPrice.value = cotizations.dolar;
    UFvalue.value = cotizations.uf;
    store.setProp({
      key: 'pricing',
      value: { dolar: dolarPrice.value, uf: UFvalue.value },
    });

    if (!dolarPrice.value || !UFvalue.value) {
      isButtonDisabled.value = true;
    } else {
      handleSliderChange(Math.round((1000 * dolarPrice.value) / UFvalue.value));
    }
  } catch (error) {
    $toast?.error(
      t(
        'nueva_operacion.nueva_operacion.hay_un_error_en_la_cotizacion_de_divisas',
      ),
    );
  } finally {
    loading.value = false;
  }
};

const handleCountrySpecificLogic = async (country: string) => {
  if (country === 'ARGENTINA') {
    await fetchDolarArgentina();
  } else if (country === 'CHILE') {
    const value = 100 * 0.31;

    await fetchDolarChile();
    endPrice.value = parseFloat((value / 100).toFixed(2));
  } else if (country === 'MEXICO') {
    endPrice.value = 0;
    // endPrice.value = calculatePolicyPrice(200000);
  }
};

onMounted(async () => {
  const { companies } = await CompaniesRepository.getCompanies();

  companiesOptions.value = companies
  .map((company: ICompany) => ({
    ...company,
    nombre: company.name,
  }))
  .filter((e: ICompany) => e.requestType === 'WEB');

});

watch(
  company,
  async (company) => {

    if (company && company.country) {
	  companyURLSelected.value = company.urlDomain
	  country.value = {id: company.country.id, nombre: company.country.description};
      await handleCountrySpecificLogic(company.country?.description);
      const assets = await getAssets(company.country?.description.substring(0, 3));

      fieldsStep1.value = fieldsStep1.value.map((field: any) => {
        if (field.key === 'asset') {
          field.options = assets;
        }

        return field;
      });
    }
  },
  {
    immediate: true,
  },
);

const handleValidateSlider = () => {
  if (country.value.nombre === 'CHILE' && dolarPrice.value && UFvalue.value) {
    return true;
  } else if (country.value.nombre === 'ARGENTINA' && dolarPrice.value) {
    return true;
  } else if (country.value.nombre === 'MEXICO') {
    return true;
  }

  isButtonDisabled.value = false;
  return false;
};

const handleSliderChange = (data: number) => {
  errorResponse.value = null;
  endPrice.value = 0;
  return (indemnificationLimit.value = data);
  // Calculo de precio final para Argentina
  if (country.value.nombre === 'ARGENTINA') {
    indemnificationLimit.value = data;

    const primaNeta = (data * 0.315) / 100;
    const recargosFinacieros = (primaNeta * 6) / 100;

    if (!dolarPrice.value) {
      return (isButtonDisabled.value = true);
    }
    //    if (
    // 	 (data / 1000 <= dolarPrice.value || data <= Math.round(dolarPrice.value * 250000)) ||
    // 	//  !toogleIndemnizationLimit.value
    //    ) {
    // 	 isButtonDisabled.value = false;
    //    } else {
    // 	 isButtonDisabled.value = true;
    //    }

    const endPriceValue = primaNeta + recargosFinacieros;
    return (endPrice.value = parseFloat(endPriceValue.toFixed(2)));
  }

  // Calculo de precio final para Chile
  if (country.value.nombre === 'CHILE') {
    indemnificationLimit.value = data;
    const value = data * 0.31;

    return (endPrice.value = parseFloat((value / 100).toFixed(2)));
  }

  // Calculo de precio final para Mexico
  indemnificationLimit.value = data;
  const value = calculatePolicyPrice(data);
  endPrice.value = parseFloat(value.toFixed(2));
};

const handleOnSubmit = ({ items, isFormValid }: any) => {
  if (!isFormValid) return;

  const newAudit = {
    email: items.email,
    phone: items.phone,
    asset: items.asset?.nombre,
  };

  dataForm1.value = {
    ...newAudit,
    asset: items.asset,
    indemnificationLimit: indemnificationLimit.value,
    endPrice: endPrice.value,
    typePolicieTransport: items.typePolicieTransport.nombre,
  };

  toogleForm2.value = true;
};

const handleReset = () => {
  toogleForm2.value = false;
};

const handleChangeInputs = async (e: any) => {
  endPrice.value = 0;
  errorResponse.value = null;

  const key = e.input.key;
  const value = e.value;
  const assetField = fieldsStep1.value.find((field: any) => field.key === 'asset');
  const subAssetField = fieldsStep1.value.find((field: any) => field.key === 'subAsset');
  const productField = fieldsStep1.value.find((field: any) => field.key === 'product');

  // --- Cambio en el campo 'asset' ---
  if (key === 'asset') {
	assetSelected.value = value;
    const subAssets = await getSubAssets(value.id);

    subAssetField.disabled = !subAssets.length;
    productField.disabled = !subAssets.length;
    await refTableForm.value.setValue({ key: 'subAsset', value: null });
    await refTableForm.value.setValue({ key: 'product', value: null });
	// const isRequired = subAssets.length;
    //   productField.required = isRequired;
    //   productField.validations = {
    //     rules: {
    //       required: isRequired,
    //     },
    //   };

    if (subAssetField) {
      subAssetField.options = subAssets;
    }
  }

  // --- Cambio en el campo 'subAsset' ---
  if (key === 'subAsset') {

    // Obtenemos productos y actualizamos el campo 'product'
    const products = await getProducts(value.id);
    if (productField) {
      productField.options = products;
      productField.disabled = false;

      await refTableForm.value.setValue({ key: 'product', value: null });

      // Reconfiguramos validaciones del campo 'product'
      const isRequired = true;
      productField.required = isRequired;
      productField.validations = {
        rules: {
          required: isRequired,
        },
      };
    }
  }
  if (key === 'typePolicieTransport') {
	const isPaqueteria = value?.nombre === 'Paqueteria';
	assetSelected.value = null;

	if (isPaqueteria) {
		// Limpiar valores relacionados
		await refTableForm.value.setValue({ key: 'asset', value: null });
		await refTableForm.value.setValue({ key: 'subAsset', value: null });
		await refTableForm.value.setValue({ key: 'product', value: null });
		assetSelected.value = {
			riskType: {
				description: 'PAQUETERIA',
			},
		} as IAsset
		// Desactivar requerimiento del campo 'product'
		productField.required = false;
		productField.validations = {
		rules: {
			required: false,
		},
		};
	}

	// Mostrar u ocultar campos según el tipo de póliza
	assetField.hidden = isPaqueteria;
	subAssetField.hidden = isPaqueteria;
	productField.hidden = isPaqueteria;

	// Ajustar validación del campo 'asset'
	assetField.validations = {
		rules: {
		required: !isPaqueteria,
		},
	};
  }

};

const handleCalculatePrice = async () => {
  try {
    //!mandar la URL por aqui
    const endPriceResponse = await calculatePriceForLanding({
      riskType: assetSelected.value?.riskType,
      indemnificationLimitMax: indemnificationLimit.value,
      assetId: assetSelected.value?.id ?? 999,
    });

    endPrice.value = endPriceResponse.calculation;
  } catch (error: any) {
    errorResponse.value = error.message;
  }
};

const handleRemoveActive = async (e: any) => {
  const key = e.input.key;
  endPrice.value = 0;
  if (key === 'asset') {
    const subAssetField = fieldsStep1.value.find(
      (field: any) => field.key === 'subAsset',
    );
    subAssetField.disabled = true;
    await refTableForm.value.setValue({ key: 'subAsset', value: null });
  }
  if (key === 'subAsset') {
    const productField = fieldsStep1.value.find(
      (field: any) => field.key === 'product',
    );
    productField.disabled = true;
    await refTableForm.value.setValue({ key: 'product', value: null });
	// Reconfiguramos validaciones del campo 'product'
	const isRequired = false;
      productField.required = isRequired;
      productField.validations = {
        rules: {
          required: isRequired,
        },
      };
  }
};
</script>

<template>
  <Layout
    :title="t('nueva_operacion.nueva_operacion.nueva_operacion')"
    :textColor="'color-secondary'"
    v-if="!toogleForm2"
  >
    <template #layout
      ><div v-if="companiesOptions.length">
        <label class="p-2 fs-5">{{ t('global.compania') }}</label>
        <Select
          class="col-4"
          :options="companiesOptions"
          :value="company"
          v-model="company"
        />
      </div>

      <Form
        ref="refTableForm"
        :inputs="fieldsStep1"
        @onSubmit="handleOnSubmit"
        @select="handleChangeInputs"
		@remove="handleRemoveActive"
      >
        <template #buttons>
          <div class="container col-6">
            <div class="row justify-content-center border-black p-4">
              <div class="col-12 px-5">
                <p class="mb-5 text-center">
                  {{
                    t(
                      'nueva_operacion.nueva_operacion.seleccione_limite_de_indemnizacion',
                    )
                  }}
                </p>
                <Overlay
                  :show="loading"
                  rounded="lg"
                  borderColor="#40a4c6"
                  circleColor="#40a4c6"
                  class="p-5"
                />
                <template v-if="!loading">
                  <div
                    class="form__slider background-blue"
                    v-if="handleValidateSlider()"
                  >
                    <Slider
                      @value="handleSliderChange"
                      :countryInitial="country.nombre"
                      :dolarPrice="dolarPrice ?? undefined"
                      :UFvalue="UFvalue ?? undefined"
                    />
                  </div>
                  <div class="d-flex justify-content-center mt-2">
                    <p>
                      <span
                        >{{
                          t('nueva_operacion.nueva_operacion.precio_final')
                        }}:</span
                      >
                      <span class="color-pink">$ {{ endPrice }}</span> + iva
                    </p>
                  </div>
                  <div
                    class="d-flex justify-content-center mt-5 d-flex flex-column justify-content-center align-items-center"
                  >
                    <p v-if="errorResponse" class="text-danger">
                      {{ errorResponse }}
                    </p>
                  </div>
				  <button
				  	  v-if="endPrice === 0"
                      class="w-100  p-1 mb-4 background-green color-white border-0 rounded-4"
                      style="font-weight: bold; font-size: 2rem"
                      @click="handleCalculatePrice"
                      :disabled="!assetSelected || !companyURLSelected"
                      type="button"
                    >
					{{t('nueva_operacion.nueva_operacion.calcular_precio')}}
                  </button>
                  <button
				 	 v-if="endPrice !== 0"
                    class="w-100 p-1 mb-4 background-pink color-white border-0 rounded-4"
                    style="font-weight: bold; font-size: 2rem"
                    :disabled="isButtonDisabled || endPrice === 0"
                  >
				 	 {{t('nueva_operacion.nueva_operacion.cargar_poliza')}}
                  </button>
                </template>
              </div>
            </div>
          </div>
        </template>
      </Form>
    </template>
  </Layout>
  <template v-else-if="country.nombre === 'MEXICO'">
    <NuevaContratacionMX :dataForm1="dataForm1" @firstView="handleReset" />
  </template>
  <template v-else-if="country.nombre === 'ARGENTINA'">
    <NuevaContratacionAR :dataForm1="dataForm1" @firstView="handleReset" />
  </template>
  <template v-else-if="country.nombre === 'CHILE'">
    <NuevaContratacionCL :dataForm1="dataForm1" @firstView="handleReset" />
  </template>
</template>
